const ATTEMPT_KEY = 'registration_attempt_id';
const START_EVENT_KEY = 'registration_start_event_id';

const createId = () => {
  if (crypto.randomUUID) return crypto.randomUUID();

  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

const getRegistrationAttemptId = () => {
  let id = sessionStorage.getItem(ATTEMPT_KEY);

  if (!id) {
    id = createId();
    sessionStorage.setItem(ATTEMPT_KEY, id);
  }

  return id;
};

const pushEvent = payload => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

export const trackRegistrationStart = () => {
  const existingEventId = sessionStorage.getItem(START_EVENT_KEY);

  if (existingEventId) return;

  const eventId = createId();
  const attemptId = getRegistrationAttemptId();

  // Сохраняем до отправки, чтобы не отправить повторно
  // при последующих изменениях полей.
  sessionStorage.setItem(START_EVENT_KEY, eventId);

  pushEvent({
    event: 'registration_start',
    event_id: eventId,
    event_time: new Date().toISOString(),
    user_id: null,
    registration_attempt_id: attemptId,
    partner_id: null,
    transaction_id: null,
    value: null,
    currency: null,
  });
};

export const trackRegistration = userId => {
  if (userId == null || userId === '') return;

  const eventKey = `registration_event_${userId}`;
  const existingEventId = sessionStorage.getItem(eventKey);

  if (existingEventId) return;

  const eventId = createId();
  const attemptId = getRegistrationAttemptId();

  sessionStorage.setItem(eventKey, eventId);

  pushEvent({
    event: 'registration',
    event_id: eventId,
    event_time: new Date().toISOString(),
    user_id: String(userId),
    registration_attempt_id: attemptId,
    partner_id: null,
    transaction_id: null,
    value: null,
    currency: null,
  });
};
